import { TabMenuBarState } from "app/pages/AgentPricing/modules/TabMenuBar/state";
import { AgentPricingTab, Action, ActionType } from "app/pages/AgentPricing/actionTypes";

const startingState : TabMenuBarState = {
    selectedTab: AgentPricingTab.GroupRates
}

export function reducer(state: TabMenuBarState|undefined, action: Action) : TabMenuBarState {
    if (!state) {
        return startingState;
    }

    switch(action.type) {
        case ActionType.ChangeTab: 
            return {
                selectedTab: action.tab
            }        
        default: 
            return state; 
    }
}